<template>
  <div class="content">
    <el-image class="logo" :src="src" fit="cover"></el-image>
    <!-- <div class="" v-html="text"> </div> -->

    <div class="ql-container ql-snow text">
      <div class="ql-editor" v-html="text"></div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css"; // import styles
import "quill/dist/quill.snow.css"; // for snow theme
import "quill/dist/quill.bubble.css"; // for bubble theme
Vue.use(VueQuillEditor);
import { adminConfigInfo } from "@/request/api";
export default {
  name: "HomeView",
  data() {
    return {
      src: "",
      text: "",
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      adminConfigInfo().then((res) => {
        console.log(res);
        // this.contact_title = res.results[0].contact_title;
        this.text = res.results[0].about_body;
        // this.logo_image = res.results[0].logo;
        // this.src = res.results[0].home_page;
        this.src = res.results[0].about_page;
      });
    },
  },
};
</script>

<style scoped>
.logo {
  width: 100%;
  height: 500px;
}
.text {
  width: 80%;
  margin: 50px auto;
}
.ql-container.ql-snow {
  border: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue